import '@adyen/adyen-web/styles/adyen.css';
import { FC } from 'react';

import { CURRENCIES } from '@savgroup-front-common/constants';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';

import { usePaymentAdyen } from './PaymentAdyen.hooks';
import { $PaymentAdyenContainer } from './PaymentAdyen.styles';

interface PaymentAdyenProps {
  onSubmitSuccess: () => Promise<void>;
  isFormCompleted: boolean;
  invoice: { id: string; priceWithTax: number; currencyTrigram: CURRENCIES };
  claimGroupId: string;
}

export const PaymentAdyen: FC<PaymentAdyenProps> = ({
  onSubmitSuccess,
  isFormCompleted,
  invoice,
  claimGroupId,
}) => {
  const { containerRef, isLoading } = usePaymentAdyen({
    invoiceId: invoice.id,
    claimGroupId,
    onSubmitSuccess,
    isFormCompleted,
  });

  if (isLoading) {
    return <BaseLoader />;
  }

  return <$PaymentAdyenContainer ref={containerRef} data-testid="paymentAdyen" />;
};
